const downloadedText = 'Scan History Downloaded';
const downloadingText = 'Downloading Scan History';
const descDownloadedText = 'download completed';
const descDownloadingText = 'estimated time remaining...32 seconds';
const ghostBtnDownloadedText = 'Download csv';
const ghostBtnDownloadingText = 'Close';
const primaryBtnDownloadedText = 'Select new date range';
const primaryBtnDownloadingText = 'Stop Download';
const percentageCompleted = '100';
const percentagePartiallyCompleted = '76';

export {
  downloadedText,
  downloadingText,
  descDownloadedText,
  descDownloadingText,
  ghostBtnDownloadedText,
  ghostBtnDownloadingText,
  primaryBtnDownloadedText,
  primaryBtnDownloadingText,
  percentageCompleted,
  percentagePartiallyCompleted
};
